/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as InviteRouteImport } from "./routes/invite"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as RegisterRouteImport } from "./routes/register"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as DashboardIndexRouteImport } from "./routes/dashboard/index"
import { Route as DashboardActivityRouteImport } from "./routes/dashboard/activity"
import { Route as DashboardContactRouteImport } from "./routes/dashboard/contact"
import { Route as DashboardContactsRouteImport } from "./routes/dashboard/contacts"
import { Route as DashboardDealRouteImport } from "./routes/dashboard/deal"
import { Route as DashboardDealsRouteImport } from "./routes/dashboard/deals"
import { Route as DashboardInboxRouteImport } from "./routes/dashboard/inbox"
import { Route as DashboardProjectRouteImport } from "./routes/dashboard/project"
import { Route as DashboardProjectsRouteImport } from "./routes/dashboard/projects"
import { Route as DashboardSettingsRouteImport } from "./routes/dashboard/settings"
import { Route as DashboardTaskRouteImport } from "./routes/dashboard/task"
import { Route as DashboardTasksRouteImport } from "./routes/dashboard/tasks"
import { Route as DashboardSettingsIndexRouteImport } from "./routes/dashboard/settings/index"
import { Route as DashboardSettingsAdminRouteImport } from "./routes/dashboard/settings/admin"
import { Route as DashboardSettingsApiKeysRouteImport } from "./routes/dashboard/settings/api-keys"
import { Route as DashboardSettingsAppearanceRouteImport } from "./routes/dashboard/settings/appearance"
import { Route as DashboardSettingsDealTypesRouteImport } from "./routes/dashboard/settings/deal-types"
import { Route as DashboardSettingsDeveloperRouteImport } from "./routes/dashboard/settings/developer"
import { Route as DashboardSettingsNotificationsRouteImport } from "./routes/dashboard/settings/notifications"
import { Route as DashboardSettingsOrganizationsRouteImport } from "./routes/dashboard/settings/organizations"
import { Route as DashboardSettingsProfileRouteImport } from "./routes/dashboard/settings/profile"
import { Route as DashboardSettingsTeamRouteImport } from "./routes/dashboard/settings/team"
import { Route as DashboardSettingsAdminOrganizationRouteImport } from "./routes/dashboard/settings/admin/organization"
import { Route as DashboardSettingsAdminUserRouteImport } from "./routes/dashboard/settings/admin/user"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: "/invite",
  path: "/invite",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardActivityRoute = DashboardActivityRouteImport.update({
  id: "/activity",
  path: "/activity",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardContactRoute = DashboardContactRouteImport.update({
  id: "/contact",
  path: "/contact",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardContactsRoute = DashboardContactsRouteImport.update({
  id: "/contacts",
  path: "/contacts",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDealRoute = DashboardDealRouteImport.update({
  id: "/deal",
  path: "/deal",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDealsRoute = DashboardDealsRouteImport.update({
  id: "/deals",
  path: "/deals",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInboxRoute = DashboardInboxRouteImport.update({
  id: "/inbox",
  path: "/inbox",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProjectRoute = DashboardProjectRouteImport.update({
  id: "/project",
  path: "/project",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProjectsRoute = DashboardProjectsRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTaskRoute = DashboardTaskRouteImport.update({
  id: "/task",
  path: "/task",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTasksRoute = DashboardTasksRouteImport.update({
  id: "/tasks",
  path: "/tasks",
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsAdminRoute = DashboardSettingsAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsApiKeysRoute =
  DashboardSettingsApiKeysRouteImport.update({
    id: "/api-keys",
    path: "/api-keys",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsAppearanceRoute =
  DashboardSettingsAppearanceRouteImport.update({
    id: "/appearance",
    path: "/appearance",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsDealTypesRoute =
  DashboardSettingsDealTypesRouteImport.update({
    id: "/deal-types",
    path: "/deal-types",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsDeveloperRoute =
  DashboardSettingsDeveloperRouteImport.update({
    id: "/developer",
    path: "/developer",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsNotificationsRoute =
  DashboardSettingsNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsOrganizationsRoute =
  DashboardSettingsOrganizationsRouteImport.update({
    id: "/organizations",
    path: "/organizations",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsProfileRoute =
  DashboardSettingsProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsTeamRoute = DashboardSettingsTeamRouteImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsAdminOrganizationRoute =
  DashboardSettingsAdminOrganizationRouteImport.update({
    id: "/organization",
    path: "/organization",
    getParentRoute: () => DashboardSettingsAdminRoute,
  } as any)
const DashboardSettingsAdminUserRoute =
  DashboardSettingsAdminUserRouteImport.update({
    id: "/user",
    path: "/user",
    getParentRoute: () => DashboardSettingsAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/dashboard": typeof DashboardRouteWithChildren
  "/forgot-password": typeof ForgotPasswordRoute
  "/invite": typeof InviteRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/reset-password": typeof ResetPasswordRoute
  "/dashboard/activity": typeof DashboardActivityRoute
  "/dashboard/contact": typeof DashboardContactRoute
  "/dashboard/contacts": typeof DashboardContactsRoute
  "/dashboard/deal": typeof DashboardDealRoute
  "/dashboard/deals": typeof DashboardDealsRoute
  "/dashboard/inbox": typeof DashboardInboxRoute
  "/dashboard/project": typeof DashboardProjectRoute
  "/dashboard/projects": typeof DashboardProjectsRoute
  "/dashboard/settings": typeof DashboardSettingsRouteWithChildren
  "/dashboard/task": typeof DashboardTaskRoute
  "/dashboard/tasks": typeof DashboardTasksRoute
  "/dashboard/": typeof DashboardIndexRoute
  "/dashboard/settings/admin": typeof DashboardSettingsAdminRouteWithChildren
  "/dashboard/settings/api-keys": typeof DashboardSettingsApiKeysRoute
  "/dashboard/settings/appearance": typeof DashboardSettingsAppearanceRoute
  "/dashboard/settings/deal-types": typeof DashboardSettingsDealTypesRoute
  "/dashboard/settings/developer": typeof DashboardSettingsDeveloperRoute
  "/dashboard/settings/notifications": typeof DashboardSettingsNotificationsRoute
  "/dashboard/settings/organizations": typeof DashboardSettingsOrganizationsRoute
  "/dashboard/settings/profile": typeof DashboardSettingsProfileRoute
  "/dashboard/settings/team": typeof DashboardSettingsTeamRoute
  "/dashboard/settings/": typeof DashboardSettingsIndexRoute
  "/dashboard/settings/admin/organization": typeof DashboardSettingsAdminOrganizationRoute
  "/dashboard/settings/admin/user": typeof DashboardSettingsAdminUserRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/invite": typeof InviteRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/reset-password": typeof ResetPasswordRoute
  "/dashboard/activity": typeof DashboardActivityRoute
  "/dashboard/contact": typeof DashboardContactRoute
  "/dashboard/contacts": typeof DashboardContactsRoute
  "/dashboard/deal": typeof DashboardDealRoute
  "/dashboard/deals": typeof DashboardDealsRoute
  "/dashboard/inbox": typeof DashboardInboxRoute
  "/dashboard/project": typeof DashboardProjectRoute
  "/dashboard/projects": typeof DashboardProjectsRoute
  "/dashboard/task": typeof DashboardTaskRoute
  "/dashboard/tasks": typeof DashboardTasksRoute
  "/dashboard": typeof DashboardIndexRoute
  "/dashboard/settings/admin": typeof DashboardSettingsAdminRouteWithChildren
  "/dashboard/settings/api-keys": typeof DashboardSettingsApiKeysRoute
  "/dashboard/settings/appearance": typeof DashboardSettingsAppearanceRoute
  "/dashboard/settings/deal-types": typeof DashboardSettingsDealTypesRoute
  "/dashboard/settings/developer": typeof DashboardSettingsDeveloperRoute
  "/dashboard/settings/notifications": typeof DashboardSettingsNotificationsRoute
  "/dashboard/settings/organizations": typeof DashboardSettingsOrganizationsRoute
  "/dashboard/settings/profile": typeof DashboardSettingsProfileRoute
  "/dashboard/settings/team": typeof DashboardSettingsTeamRoute
  "/dashboard/settings": typeof DashboardSettingsIndexRoute
  "/dashboard/settings/admin/organization": typeof DashboardSettingsAdminOrganizationRoute
  "/dashboard/settings/admin/user": typeof DashboardSettingsAdminUserRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/dashboard": typeof DashboardRouteWithChildren
  "/forgot-password": typeof ForgotPasswordRoute
  "/invite": typeof InviteRoute
  "/login": typeof LoginRoute
  "/register": typeof RegisterRoute
  "/reset-password": typeof ResetPasswordRoute
  "/dashboard/activity": typeof DashboardActivityRoute
  "/dashboard/contact": typeof DashboardContactRoute
  "/dashboard/contacts": typeof DashboardContactsRoute
  "/dashboard/deal": typeof DashboardDealRoute
  "/dashboard/deals": typeof DashboardDealsRoute
  "/dashboard/inbox": typeof DashboardInboxRoute
  "/dashboard/project": typeof DashboardProjectRoute
  "/dashboard/projects": typeof DashboardProjectsRoute
  "/dashboard/settings": typeof DashboardSettingsRouteWithChildren
  "/dashboard/task": typeof DashboardTaskRoute
  "/dashboard/tasks": typeof DashboardTasksRoute
  "/dashboard/": typeof DashboardIndexRoute
  "/dashboard/settings/admin": typeof DashboardSettingsAdminRouteWithChildren
  "/dashboard/settings/api-keys": typeof DashboardSettingsApiKeysRoute
  "/dashboard/settings/appearance": typeof DashboardSettingsAppearanceRoute
  "/dashboard/settings/deal-types": typeof DashboardSettingsDealTypesRoute
  "/dashboard/settings/developer": typeof DashboardSettingsDeveloperRoute
  "/dashboard/settings/notifications": typeof DashboardSettingsNotificationsRoute
  "/dashboard/settings/organizations": typeof DashboardSettingsOrganizationsRoute
  "/dashboard/settings/profile": typeof DashboardSettingsProfileRoute
  "/dashboard/settings/team": typeof DashboardSettingsTeamRoute
  "/dashboard/settings/": typeof DashboardSettingsIndexRoute
  "/dashboard/settings/admin/organization": typeof DashboardSettingsAdminOrganizationRoute
  "/dashboard/settings/admin/user": typeof DashboardSettingsAdminUserRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/dashboard"
    | "/forgot-password"
    | "/invite"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/dashboard/activity"
    | "/dashboard/contact"
    | "/dashboard/contacts"
    | "/dashboard/deal"
    | "/dashboard/deals"
    | "/dashboard/inbox"
    | "/dashboard/project"
    | "/dashboard/projects"
    | "/dashboard/settings"
    | "/dashboard/task"
    | "/dashboard/tasks"
    | "/dashboard/"
    | "/dashboard/settings/admin"
    | "/dashboard/settings/api-keys"
    | "/dashboard/settings/appearance"
    | "/dashboard/settings/deal-types"
    | "/dashboard/settings/developer"
    | "/dashboard/settings/notifications"
    | "/dashboard/settings/organizations"
    | "/dashboard/settings/profile"
    | "/dashboard/settings/team"
    | "/dashboard/settings/"
    | "/dashboard/settings/admin/organization"
    | "/dashboard/settings/admin/user"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/forgot-password"
    | "/invite"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/dashboard/activity"
    | "/dashboard/contact"
    | "/dashboard/contacts"
    | "/dashboard/deal"
    | "/dashboard/deals"
    | "/dashboard/inbox"
    | "/dashboard/project"
    | "/dashboard/projects"
    | "/dashboard/task"
    | "/dashboard/tasks"
    | "/dashboard"
    | "/dashboard/settings/admin"
    | "/dashboard/settings/api-keys"
    | "/dashboard/settings/appearance"
    | "/dashboard/settings/deal-types"
    | "/dashboard/settings/developer"
    | "/dashboard/settings/notifications"
    | "/dashboard/settings/organizations"
    | "/dashboard/settings/profile"
    | "/dashboard/settings/team"
    | "/dashboard/settings"
    | "/dashboard/settings/admin/organization"
    | "/dashboard/settings/admin/user"
  id:
    | "__root__"
    | "/"
    | "/dashboard"
    | "/forgot-password"
    | "/invite"
    | "/login"
    | "/register"
    | "/reset-password"
    | "/dashboard/activity"
    | "/dashboard/contact"
    | "/dashboard/contacts"
    | "/dashboard/deal"
    | "/dashboard/deals"
    | "/dashboard/inbox"
    | "/dashboard/project"
    | "/dashboard/projects"
    | "/dashboard/settings"
    | "/dashboard/task"
    | "/dashboard/tasks"
    | "/dashboard/"
    | "/dashboard/settings/admin"
    | "/dashboard/settings/api-keys"
    | "/dashboard/settings/appearance"
    | "/dashboard/settings/deal-types"
    | "/dashboard/settings/developer"
    | "/dashboard/settings/notifications"
    | "/dashboard/settings/organizations"
    | "/dashboard/settings/profile"
    | "/dashboard/settings/team"
    | "/dashboard/settings/"
    | "/dashboard/settings/admin/organization"
    | "/dashboard/settings/admin/user"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite": {
      id: "/invite"
      path: "/invite"
      fullPath: "/invite"
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/register": {
      id: "/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard/": {
      id: "/dashboard/"
      path: "/"
      fullPath: "/dashboard/"
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/activity": {
      id: "/dashboard/activity"
      path: "/activity"
      fullPath: "/dashboard/activity"
      preLoaderRoute: typeof DashboardActivityRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/contact": {
      id: "/dashboard/contact"
      path: "/contact"
      fullPath: "/dashboard/contact"
      preLoaderRoute: typeof DashboardContactRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/contacts": {
      id: "/dashboard/contacts"
      path: "/contacts"
      fullPath: "/dashboard/contacts"
      preLoaderRoute: typeof DashboardContactsRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/deal": {
      id: "/dashboard/deal"
      path: "/deal"
      fullPath: "/dashboard/deal"
      preLoaderRoute: typeof DashboardDealRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/deals": {
      id: "/dashboard/deals"
      path: "/deals"
      fullPath: "/dashboard/deals"
      preLoaderRoute: typeof DashboardDealsRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/inbox": {
      id: "/dashboard/inbox"
      path: "/inbox"
      fullPath: "/dashboard/inbox"
      preLoaderRoute: typeof DashboardInboxRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/project": {
      id: "/dashboard/project"
      path: "/project"
      fullPath: "/dashboard/project"
      preLoaderRoute: typeof DashboardProjectRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/projects": {
      id: "/dashboard/projects"
      path: "/projects"
      fullPath: "/dashboard/projects"
      preLoaderRoute: typeof DashboardProjectsRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/settings": {
      id: "/dashboard/settings"
      path: "/settings"
      fullPath: "/dashboard/settings"
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/task": {
      id: "/dashboard/task"
      path: "/task"
      fullPath: "/dashboard/task"
      preLoaderRoute: typeof DashboardTaskRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/tasks": {
      id: "/dashboard/tasks"
      path: "/tasks"
      fullPath: "/dashboard/tasks"
      preLoaderRoute: typeof DashboardTasksRouteImport
      parentRoute: typeof DashboardRoute
    }
    "/dashboard/settings/": {
      id: "/dashboard/settings/"
      path: "/"
      fullPath: "/dashboard/settings/"
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/admin": {
      id: "/dashboard/settings/admin"
      path: "/admin"
      fullPath: "/dashboard/settings/admin"
      preLoaderRoute: typeof DashboardSettingsAdminRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/api-keys": {
      id: "/dashboard/settings/api-keys"
      path: "/api-keys"
      fullPath: "/dashboard/settings/api-keys"
      preLoaderRoute: typeof DashboardSettingsApiKeysRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/appearance": {
      id: "/dashboard/settings/appearance"
      path: "/appearance"
      fullPath: "/dashboard/settings/appearance"
      preLoaderRoute: typeof DashboardSettingsAppearanceRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/deal-types": {
      id: "/dashboard/settings/deal-types"
      path: "/deal-types"
      fullPath: "/dashboard/settings/deal-types"
      preLoaderRoute: typeof DashboardSettingsDealTypesRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/developer": {
      id: "/dashboard/settings/developer"
      path: "/developer"
      fullPath: "/dashboard/settings/developer"
      preLoaderRoute: typeof DashboardSettingsDeveloperRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/notifications": {
      id: "/dashboard/settings/notifications"
      path: "/notifications"
      fullPath: "/dashboard/settings/notifications"
      preLoaderRoute: typeof DashboardSettingsNotificationsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/organizations": {
      id: "/dashboard/settings/organizations"
      path: "/organizations"
      fullPath: "/dashboard/settings/organizations"
      preLoaderRoute: typeof DashboardSettingsOrganizationsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/profile": {
      id: "/dashboard/settings/profile"
      path: "/profile"
      fullPath: "/dashboard/settings/profile"
      preLoaderRoute: typeof DashboardSettingsProfileRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/team": {
      id: "/dashboard/settings/team"
      path: "/team"
      fullPath: "/dashboard/settings/team"
      preLoaderRoute: typeof DashboardSettingsTeamRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    "/dashboard/settings/admin/organization": {
      id: "/dashboard/settings/admin/organization"
      path: "/organization"
      fullPath: "/dashboard/settings/admin/organization"
      preLoaderRoute: typeof DashboardSettingsAdminOrganizationRouteImport
      parentRoute: typeof DashboardSettingsAdminRoute
    }
    "/dashboard/settings/admin/user": {
      id: "/dashboard/settings/admin/user"
      path: "/user"
      fullPath: "/dashboard/settings/admin/user"
      preLoaderRoute: typeof DashboardSettingsAdminUserRouteImport
      parentRoute: typeof DashboardSettingsAdminRoute
    }
  }
}

interface DashboardSettingsAdminRouteChildren {
  DashboardSettingsAdminOrganizationRoute: typeof DashboardSettingsAdminOrganizationRoute
  DashboardSettingsAdminUserRoute: typeof DashboardSettingsAdminUserRoute
}

const DashboardSettingsAdminRouteChildren: DashboardSettingsAdminRouteChildren =
  {
    DashboardSettingsAdminOrganizationRoute:
      DashboardSettingsAdminOrganizationRoute,
    DashboardSettingsAdminUserRoute: DashboardSettingsAdminUserRoute,
  }

const DashboardSettingsAdminRouteWithChildren =
  DashboardSettingsAdminRoute._addFileChildren(
    DashboardSettingsAdminRouteChildren,
  )

interface DashboardSettingsRouteChildren {
  DashboardSettingsAdminRoute: typeof DashboardSettingsAdminRouteWithChildren
  DashboardSettingsApiKeysRoute: typeof DashboardSettingsApiKeysRoute
  DashboardSettingsAppearanceRoute: typeof DashboardSettingsAppearanceRoute
  DashboardSettingsDealTypesRoute: typeof DashboardSettingsDealTypesRoute
  DashboardSettingsDeveloperRoute: typeof DashboardSettingsDeveloperRoute
  DashboardSettingsNotificationsRoute: typeof DashboardSettingsNotificationsRoute
  DashboardSettingsOrganizationsRoute: typeof DashboardSettingsOrganizationsRoute
  DashboardSettingsProfileRoute: typeof DashboardSettingsProfileRoute
  DashboardSettingsTeamRoute: typeof DashboardSettingsTeamRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsAdminRoute: DashboardSettingsAdminRouteWithChildren,
  DashboardSettingsApiKeysRoute: DashboardSettingsApiKeysRoute,
  DashboardSettingsAppearanceRoute: DashboardSettingsAppearanceRoute,
  DashboardSettingsDealTypesRoute: DashboardSettingsDealTypesRoute,
  DashboardSettingsDeveloperRoute: DashboardSettingsDeveloperRoute,
  DashboardSettingsNotificationsRoute: DashboardSettingsNotificationsRoute,
  DashboardSettingsOrganizationsRoute: DashboardSettingsOrganizationsRoute,
  DashboardSettingsProfileRoute: DashboardSettingsProfileRoute,
  DashboardSettingsTeamRoute: DashboardSettingsTeamRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardRouteChildren {
  DashboardActivityRoute: typeof DashboardActivityRoute
  DashboardContactRoute: typeof DashboardContactRoute
  DashboardContactsRoute: typeof DashboardContactsRoute
  DashboardDealRoute: typeof DashboardDealRoute
  DashboardDealsRoute: typeof DashboardDealsRoute
  DashboardInboxRoute: typeof DashboardInboxRoute
  DashboardProjectRoute: typeof DashboardProjectRoute
  DashboardProjectsRoute: typeof DashboardProjectsRoute
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
  DashboardTaskRoute: typeof DashboardTaskRoute
  DashboardTasksRoute: typeof DashboardTasksRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardActivityRoute: DashboardActivityRoute,
  DashboardContactRoute: DashboardContactRoute,
  DashboardContactsRoute: DashboardContactsRoute,
  DashboardDealRoute: DashboardDealRoute,
  DashboardDealsRoute: DashboardDealsRoute,
  DashboardInboxRoute: DashboardInboxRoute,
  DashboardProjectRoute: DashboardProjectRoute,
  DashboardProjectsRoute: DashboardProjectsRoute,
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
  DashboardTaskRoute: DashboardTaskRoute,
  DashboardTasksRoute: DashboardTasksRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
